// import FormsEditorPage from './FormsEditorPage.vue';
// import FormRendererContrato from '@/components/SettingTables/configurations/FormContrato.vue';s
// import FormPeriodoConciliacion from '@/components/SettingTables/configurations/FormPeriodoConciliacion.vue';
// import ConciliacionHistoryForm from '@/components/SettingTables/configurations/ConciliacionHistoryForm.vue';
const FormsEditorPage = () => import('./FormsEditorPage.vue')
const FormRendererContrato = () => import('@/components/SettingTables/configurations/contratos/FormContrato.vue')
const FormPeriodoConciliacion = () => import('@/components/SettingTables/configurations/FormPeriodoConciliacion.vue')
const ConciliacionHistoryForm = () => import('@/components/SettingTables/configurations/ConciliacionHistoryForm.vue')
const FormConciliacion = () => import('@/components/SettingTables/configurations/FormConciliacion.vue')
const formRoutes = [
    {
        path: 'formeditor',
        component: FormsEditorPage
    },
    {
        path: 'editor/:id',
        component: FormsEditorPage
    },
    {  
        path: 'contratos',
        component: FormRendererContrato
    },
    {
        path: 'periodoconciliacion/convenios',
        component: FormPeriodoConciliacion,
        props: { filters: [
            {member: 'reconcil_type_id', operator: 'equals', values: [8, 9, 10, 11, 12, 13, 14, 15, 16, 27, 28, 29, 30, 31, 42, 83]},
        ] },
    },
    // query = {
    //     # "columns": [ 'tbl_reconciliation_type.reconcil_type_id', 'tbl_reconciliation_type.reconcil_group' ],
    //     "columns": [ 'tbl_reconciliation_type.reconcil_type_id' ],
    //     'filters': [
    //         { 'member': 'tbl_reconciliation_type.reconcil_group', 'operator': 'equals', 'values': ['BANCARIA']}
    //     ]
    // }
    {
        path: 'periodoconciliacion/bancaria',
        component: FormPeriodoConciliacion,
        props: { filters: [
            {member: 'reconcil_type_id', operator: 'equals', values: [34, 37, 38, 50, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 84, 85, 86]},
        ] },
    },
    {
        path: 'periodoconciliacion/dian',
        component: FormPeriodoConciliacion,
        props: { filters: [
            {member: 'reconcil_type_id', operator: 'equals', values: [46,48,49,82]},
        ] },
    },
    {
        path: 'conciliacionhistory',
        component: ConciliacionHistoryForm
    },

    {
        path: 'conciliacion',
        component: FormConciliacion,
    }
]

export default formRoutes
